/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { SearchFacet } from '@toucan/common/services/search/constants';

import CrossIcon from '@toucan/client/global/icons/legacy/cross.svg';

import {
    IconButton,
    IconButtonFill,
    IconButtonSize,
} from '@toucan/client/shared/components/icon-button';

import { styles } from './active-filter.styles';
import { ActiveFilterProps } from './types';

const StyledActiveFilter = styled('li').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const ActiveFilter: FunctionComponent<ActiveFilterProps> = ({
    activeFilter,
    onRemove,
    ...otherProps
}: ActiveFilterProps) => {
    const { t } = useTranslation();

    const criteriaLabels: Partial<Record<SearchFacet, string>> = {
        [SearchFacet.productPriceModifier]: t('Accessory'),
    };

    const renderLabel = () => {
        const criteriaLabel =
            criteriaLabels[activeFilter.id] ?? activeFilter.title;

        if (!criteriaLabel) {
            return activeFilter.label;
        }

        return t('{{criteriaLabel}}: {{label}}', {
            criteriaLabel,
            label: activeFilter.label,
        });
    };

    return (
        <StyledActiveFilter {...otherProps}>
            {renderLabel()}
            <IconButton
                label={`Remove ${activeFilter.label}`}
                fill={IconButtonFill.HOLLOW}
                border={false}
                onClick={() => onRemove(activeFilter)}
                size={IconButtonSize.SMALL}
            >
                <CrossIcon />
            </IconButton>
        </StyledActiveFilter>
    );
};
